import styled, { css } from 'styled-components';

export const VoucherContainer = styled.div`
  margin-left: 30px;
  display: inline-block;
  ${(props) =>
    props.inline &&
    css`
      margin-left: 0;
      margin-right: 30px;
      margin-bottom: 5px;
    `}
`;
